module.exports = __webpack_public_path__ + "static/media/15_horse_dong.e062b0ab.png";